import React from 'react'

const QlpSearch = () => {
    return (
        <div>
            <h1>Qlp Search</h1>
        </div>
    )
}

export default QlpSearch
